import { Button, Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../../components/Components";
import { TypeUnidadesCargaVazia } from "../../../../lists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { InfMDFesInterface, InfUnidCargaInterface, infUnidTranspInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { Link } from "react-router-dom";
import { formatMoeda, getUuidV4 } from "../../../../utils/utils";
import MDFesUnidadeTranspInfLacreCargaInfUnidadeCargaLacres from "./MDFesUnidadeTranspInfLacreCargaInfUnidadeCargaLacres";

const initialForm: InfUnidCargaInterface = {
    id: 0,
    idunidcarga: '',
    qtdrat: 0,
    tpunidcarga: 1,
    lacUnidCarga: [],
    
};

interface formProps {
    notaFiscal: InfMDFesInterface;
    setNotaFiscal: React.Dispatch<React.SetStateAction<InfMDFesInterface>>;
    id: number | string;
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const MDFesUnidadeTranspInfLacreCargaInfUnidadeCarga: React.FC<formProps> = ({ notaFiscal, setNotaFiscal, id }) =>{
    const [form, setForm] = useState<InfUnidCargaInterface>(initialForm)
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const idunidcargaRef = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }
        
    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleChange = (e: any) => {
        const {name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const validaPreenchimento = () => {
        if (form.idunidcarga.toString().trim() === "") {
            alerta("Informe o identificador");
            return false;
        }
        
        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {

            notaFiscal.infUnidTransp?.filter(f => f.id.toString()===id.toString())[0].infUnidCarga?.push({
                id: getUuidV4(),
                idunidcarga: form.idunidcarga,
                qtdrat: form.qtdrat,
                tpunidcarga: form.tpunidcarga,
                lacUnidCarga: [...form.lacUnidCarga?? []]
            });

            setForm({
                ...initialForm,
                lacUnidCarga: []
            });
        }
    }

    const handleRemover = (key: number | string) => {
        if (notaFiscal.infUnidTransp) {
            const infUnidadeTransporte = notaFiscal.infUnidTransp.filter(item => 
                item.id.toString() === id.toString())
            
            const index = notaFiscal.infUnidTransp.findIndex((item: infUnidTranspInterface) => 
                item.id.toString() === id.toString())

            if (index !== -1) {
                let newLista = notaFiscal.infUnidTransp[index].infUnidCarga?.filter(item => 
                    item.id.toString() !== key.toString()) || [];
                
                setNotaFiscal({
                    ...notaFiscal,
                    infUnidTransp: [
                        ...notaFiscal.infUnidTransp.filter(item => item.id.toString() !== id.toString()),
                        {
                            id: infUnidadeTransporte[0].id,
                            idunidtransp: infUnidadeTransporte[0].idunidtransp,
                            qtdrat: infUnidadeTransporte[0].qtdrat,
                            tpunidtransp: infUnidadeTransporte[0].tpunidtransp,
                            lacUnidTransp: infUnidadeTransporte[0].lacUnidTransp,
                            infUnidCarga: newLista
                        }
                    ]
                })
            }
        }
        setShowModal(false);
    }

   useEffect(()=>{
    setForm({
        ...initialForm,
        lacUnidCarga: []
    });
   },[])

    return (<>
        <JRow className="mb-3 mt-2">
            <Col md>
                <JRow className="mb-3 pe-2 border-end">
                    <Col md>
                        <Form.Group>
                            <Form.Label>Tipo Unid. Carga.</Form.Label>
                            <Form.Select name="tpunidcarga" onChange={handleChange} value={form.tpunidcarga}>
                                {TypeUnidadesCargaVazia.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Identificação</Form.Label>
                            <Form.Control type="text" name="idunidcarga" maxLength={20} value={form.idunidcarga}
                                ref={idunidcargaRef}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>Rateio</Form.Label>
                            <Form.Control type="number" name="qtdrat" min={0} value={form.qtdrat}
                                // onChange={handleChange} 
                                onChange={(e) => {
                                    const {name, value} = e.target;
                                    setForm({
                                        ...form,
                                        [name]: 
                                            value.replace(/[^0-9.]/g, "")
                                            .replace(/^(\d{0,3})\d*/, "$1")
                                            .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }} 
                                />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button variant="primary" onClick={handleAdd} >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>

                

                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '4.5rem' }}>#</th>
                            <th>Tipo Unid. Carga</th>
                            <th>Identificador</th>
                            <th>Qtd. Rateio</th>
                        </tr>
                    </thead>
                    <tbody>

                        {notaFiscal.infUnidTransp?.filter(f => f.id.toString() === id.toString()).flatMap(m => 
                            m.infUnidCarga).map(item => {
                            return (
                                <tr key={item?.id}>
                                    <td className="text-center">
                                        <Link to={''} className="text-danger">
                                            <FontAwesomeIcon icon={faTrash} onClick={() => 
                                                handleOpenModal({id: item?.id ?? '', title: item?.idunidcarga??''})}/>
                                        </Link>
                                    </td>
                                    <td>
                                        {TypeUnidadesCargaVazia.find((i) => (
                                                i.id.toString() === item?.tpunidcarga.toString()
                                            ))?.name
                                        }
                                    </td>

                                    
                                    <td>{ item?.idunidcarga }</td>
                                    <td>{ formatMoeda(item?.qtdrat ?? 0 ,3) }</td>
                                </tr>
                                )
                            })
                        }

                    </tbody>
                </Table>
                </JRow>
            </Col>
            
            <Col md>
               <MDFesUnidadeTranspInfLacreCargaInfUnidadeCargaLacres form={form} setForm={setForm} />
            </Col>
        </JRow>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default MDFesUnidadeTranspInfLacreCargaInfUnidadeCarga;